import React from 'react';
import './index.scss';

import Discover from "./Discover"
import ProductRange from "./ProductRange";
import TryLenses from "./TryLenses";
import HomeAppPromo from "./HomeAppPromo";
import { ReferencesDiscover as References } from "../../components/references";
import ShopNow from "../../components/showNow";
// import ShopNow from "./ShopNow";

import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl'
import { Helmet } from 'react-helmet';

const DiscoverPage = () => {
  const intl = useIntl();
  const currentLocale = intl.locale;

  const title = intl.formatMessage({ id: 'meta.title.discover', defaultMessage: 'Discover the ACUVUE® DEFINE® catalogue' });
  const description = intl.formatMessage({ id: 'meta.desc.discover', defaultMessage: 'Craft your beautiful with a range of natural-toned hues and nature-inspired colours' });
  
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Helmet>
      <main className="content--main discover-page">
        <Discover />
        <ProductRange />
        <TryLenses />
        {/* <!-- App Promo --> */}
        {/* <HomeAppPromo /> */}
        <ShopNow />
      </main>
      { !(currentLocale == "th") &&
        (
        <References>
          <FormattedHTMLMessage
            id="discover_references"
            defaultMessage="<h1>REFERENCES/ DISCLAIMER</h1> <p> ** LACREON* Technology is Johnson & Johnson Vision Care, Inc.'s brand name for its proprietary technology that permanently embeds a water-holding ingredient, similar to that found in natural tears, into the proven etafilcon A material. </p> <h1>Important information for contact lens wearers</h1> <p>ACUVUE® Brand Contact Lenses are available by prescription only for vision correction. An eye care professional will determine whether contact lenses are right for you. Although rare, serious eye problems can develop while wearing contact lenses. To help avoid these problems, follow the wear and replacement schedule and the lens care instructions provided by your eye doctor. Do not wear contact lenses if you have an eye infection, or experience eye discomfort, excessive tearing, vision changes, redness or other eye problems. If one of these conditions occurs, contact your eye doctor immediately. For more information on proper wear, care and safety, talk to your Eye Care Professional or refer to ACUVUE®'s <a href='https://www.acuvue.com.my/patient-instruction-guides?_gl=1%2A5j622a%2A_ga%2AMTY3MjYyODQ5MC4xNzA5NzA2Mzk2%2A_ga_V5PVFGQ8H6%2AMTcwOTcwNjM5NS4xLjAuMTcwOTcwNjM5NS42MC4wLjA'> Patient Instruction Guide</a>. </p>"
          />
        </References>
        )
      }
    </>
  );
};

export default DiscoverPage;
